module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Notes")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("Bible references ")]), _vm._v("throughout are to the 1984 edition of the New International Version, unless indicated otherwise. The lower-case letters a, b, c, etc., refer to the lines within the verse in question.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("The Divine Name. ")]), _vm._v("In the Hebrew Old Testament, the personal name for the God of Israel was denoted by four Hebrew consonants, usually understood as expressing the form "), _c('i', [_vm._v("Yahweh. ")]), _vm._v("A strange scruple has, for the most part, prevented translators of the English Bible from using the Divine Name, adopting the convention of four upper-case letters, L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", instead. The form ‘Lord’ represents a Hebrew noun ("), _c('i', [_vm._v("’"), _c('span', {
    staticClass: "mev"
  }, [_vm._v("ǎ")]), _vm._v("dōnāy")]), _vm._v(") meaning exactly that.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("Inclusio. ")]), _vm._v("Developments in our understanding of the structures of Hebrew poetry (see, e.g., E. R. Follis [ed.], "), _c('i', [_vm._v("Directions in Biblical Hebrew Poetry ")]), _vm._v("[Sheffield Academic Press, 1986]) have noted the feature called ‘inclusio’, meaning the ‘bracketing’ of a poem or stanza by identical words or matching thoughts.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("The ‘square root’ sign ")]), _vm._v("(√) is used as a convenient way of expressing the root form of Hebrew verbs, e.g. on 4:1, p. 66.")])])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0